import { render } from "./RichMenuPreview.vue?vue&type=template&id=1ecff481&scoped=true"
import script from "./RichMenuPreview.vue?vue&type=script&lang=js"
export * from "./RichMenuPreview.vue?vue&type=script&lang=js"

import "./RichMenuPreview.vue?vue&type=style&index=0&id=1ecff481&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecff481"]])

export default __exports__